// @flow

export const IFRAME_EVENT_NAMES = {
  PAGE_VIEW: "pageView",
  SEARCH: "search",
  VIEW_DETAILS: "viewDetails",
  OPENED_BOOKING: "openedBooking",
  SUCCESSFUL_BOOKING: "successfulBooking",
  FRIEND_INVITE: "friendInvite",
  PARTNER_BOOKING: "partnerBooking",
}
